import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ImageText from "../common/imageText";
import ImageButtonList from "../common/imageButtonList";

class Popup extends Component {
  submitImage = require("./images/survey/1274_1210_Popup.png");
  submitButtons = [
    {
      id: "submit",
      to: "/care_team/list",
      className: "submit",
      unhighlight: require("./images/survey/1274_1210_popup_SelectContinue.png"),
    },
  ];
  render() {
    const textImage = this.props.popup === "submit" ? this.submitImage : "";
    const buttons = this.props.popup === "submit" ? this.submitButtons : "";
    return (
      <div className="submit-popup">
        <ImageText id="text" src={textImage} />
        <ImageButtonList imageButtons={buttons} flexClass="flex-vertical" />
      </div>
    );
  }
}

export default withRouter(Popup);
